import React from 'react';
import type { SignupFlow } from 'corgi-types';
import type { SpaceProps } from 'styled-system';

import { Button } from 'common/components/Button';
import SeparatorWithText from 'common/components/SeparatorWithText';
import { BodyRegularBR2, HeadlineH8 } from 'common/components/Typography';
import { useLocalization } from 'common/providers/LocaleProvider';
import { useRouter } from 'common/providers/RouterProvider';
import { Event } from 'common/types/auth';
import { getCtaCheckoutGuestHref } from 'common/utils/signup';

type CtaCheckoutGuestProps = SpaceProps & {
  userFlow: SignupFlow;
  withSeparator?: boolean;
  onClick?: () => void | Promise<void>;
};

const CtaCheckoutGuest = ({
  userFlow,
  withSeparator,
  onClick,
  ...spaceProps
}: CtaCheckoutGuestProps) => {
  const router = useRouter();
  const { p, t } = useLocalization();
  const buttonText = t('h24_proceed_as_guest');

  const handleClick = async () => {
    if (onClick) {
      await onClick();
      router.push(p(getCtaCheckoutGuestHref(userFlow)));
    } else {
      router.push(p(getCtaCheckoutGuestHref(userFlow)));
    }
  };

  return (
    <>
      {withSeparator && (
        <SeparatorWithText mt="sp_8" mb="sp_16">
          <BodyRegularBR2>{t('h24_or')}</BodyRegularBR2>
        </SeparatorWithText>
      )}
      <Button
        py="sp_12"
        kind="secondary"
        onClick={handleClick}
        tracking={{
          eventName: Event.LoginFormClick,
          text: buttonText,
        }}
        color="sys.neutral.text.default"
        {...spaceProps}
      >
        <HeadlineH8 color="sys.neutral.text.default">{buttonText}</HeadlineH8>
      </Button>
    </>
  );
};

export default CtaCheckoutGuest;
